import { configureStore } from "@reduxjs/toolkit";
import storeReducer from "./store";

const store = configureStore({
  reducer: {
    store: storeReducer,
  },
});

// Export as named export for store.getState() usage
export { store };

// Export as default for backward compatibility
export default store;
